export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

	$.fn.doubleTapToGo = function()
	{
		if( !( 'ontouchstart' in window ) &&
			!navigator.msMaxTouchPoints &&
			!navigator.userAgent.toLowerCase().match( /windows phone os 7/i ) ) return false;

		this.each( function()
		{
			var curItem = false;

			$( this ).on( 'click', function( e )
			{
				var item = $( this );
				if( item[ 0 ] != curItem[ 0 ] )
				{
					e.preventDefault();
					curItem = item;
				}
			});

			$( document ).on( 'click touchstart MSPointerDown', function( e )
			{
				var resetItem = true,
					parents	  = $( e.target ).parents();

				for( var i = 0; i < parents.length; i++ )
					if( parents[ i ] == curItem[ 0 ] )
						resetItem = false;

				if( resetItem )
					curItem = false;
			});
		});
		return this;
	};

    // JavaScript to be fired on all pages, after page specific JS is fired
    $(".slider-bateau").slick({
		dots: true,
		autoplay: true,
		infinite: false,
		prevArrow: '<button type="button" class="slick-prev">Previous</button>',
		nextArrow: '<button type="button" class="slick-next">Next</button>',
		autoplaySpeed: 2000,
		dotsClass: 'custom-dots',
		customPaging: function (slider, i) {
			var slideNumber = (i + 1), totalSlides = slider.slideCount;
			return '<a class="dot" role="button" title="' + slideNumber + ' of ' + totalSlides + '"></a>';
		},
	});

    $('.js-scrollTo').on('click', function() { // Au clic sur un élément
		var page = $(this).attr('href'); // Page cible
		var speed = 750; // Durée de l'animation (en ms)
		$('html, body').animate( { scrollTop: ($(page).offset().top)-150 }, speed ); // Go
		return false;
	});


	$('#nav-icon1').click(function(){
		$(this).toggleClass('open');
		$('#main-container').toggleClass('main-container-opened');
		$('.mobile-menu').toggleClass('mobile-menu-opened');
		// Pour empecher le scroll lors de l'ouveture du menu mobile
		$('body').toggleClass('overflow-hidden');
	});

	$( 'ul#menu-mobile-menu li.menu-item-has-children' ).doubleTapToGo();

	$('#search-icon').click(function(){
		$('.search-overlay-container').toggleClass('search-overlay-container-opened');
	});

	$('#close-search-icon').click(function(){
		$('.search-overlay-container').toggleClass('search-overlay-container-opened');
	});

	$(document).scroll(function() {
		var y = $(this).scrollTop();
		if (y > 200) {
			$('.back-to-top').addClass('back-to-top-show');
		} else {
			$('.back-to-top').removeClass('back-to-top-show');
		}
	});
	
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js